// @flow
import { users } from './api/ava';

export const getConversationCloseReason = ({
  currentUser,
  endedByCurrentUser,
  endedDueToConvoRestrictedSession,
  host,
  isClosingApp,
}: {
  currentUser: Object,
  endedByCurrentUser: boolean,
  endedDueToConvoRestrictedSession: boolean,
  host: Object,
  isClosingApp?: boolean,
}): string => {
  let reason: string = '';

  if (isClosingApp) {
    reason = 'app_terminated';
  } else if (endedDueToConvoRestrictedSession) {
    reason = 'max_convo_time_reached';
  } else if (endedByCurrentUser && host?.avaId !== currentUser.avaId) {
    reason = 'closed';
  } else if (!endedByCurrentUser && host.avaId === currentUser) {
    reason = 'last_guest_left';
  } else {
    reason = 'host_left';
  }

  return reason;
};

export const getConversationTimeInSeconds = (startTimestampMs: number) => {
  return Math.floor((Date.now() - startTimestampMs) / 1000);
};

const getConversationTotalWords = ({
  wordsCapturedGroup,
  wordsTypedGroup,
}: {
  wordsCapturedGroup: number,
  wordsTypedGroup: number,
}) => {
  return wordsTypedGroup + wordsCapturedGroup;
};

export const getMetricsToUpdate = ({
  conversationTimeInSeconds,
  isSoloConvo,
  transcriptSaved,
  transcriptStats,
}: {
  conversationTimeInSeconds: number,
  isSoloConvo: boolean,
  transcriptSaved: boolean,
  transcriptStats: Object,
}): Object => {
  const isGroupConvo = !isSoloConvo;
  const conversationTotalWords = getConversationTotalWords(transcriptStats);

  const metricsToUpdate: Object = {
    'Total Convo Time': conversationTimeInSeconds,
    'Total Saved Transcripts': transcriptSaved ? 1 : 0,
    'Total Solo Time': isSoloConvo ? conversationTimeInSeconds : 0,
    'Total Group Time': isGroupConvo ? conversationTimeInSeconds : 0,
    'Total Conversations': 1,
    'Total Convo Words': conversationTotalWords,
    'Total Solo Words': isSoloConvo ? conversationTotalWords : 0,
    'Total Group Words': isGroupConvo ? conversationTotalWords : 0,
    'Total Solo Conversations Web': isSoloConvo ? 1 : 0,
    'Total Group Conversations Web': isGroupConvo ? 1 : 0,
  };

  if (isSoloConvo) {
    metricsToUpdate.NB_SOLO_CONVO = 1;
  } else {
    metricsToUpdate.NB_GROUP_CONVO = 1;
  }

  return metricsToUpdate;
};

export const isFirstConvo = (currentMetrics: Object) => {
  return !currentMetrics || (!currentMetrics.NB_SOLO_CONVO && !currentMetrics.NB_GROUP_CONVO);
};

export const isHost = ({ host, user }: { host: Object, user: Object }) => {
  return host && host.avaId === user.avaId;
};

export const isScribeRequester = ({ scribe, user }: { scribe: Object, user: Object }) => {
  return scribe && scribe.requestor === user.avaId;
};

export const updateConversationMetrics = async ({
  metricsToUpdate,
  user,
}: {
  metricsToUpdate: Object,
  user: Object,
}) => {
  const { avaId, firebaseAuthUID, id } = user;

  await users.updateMetrics({
    avaId,
    firebaseAuthUID: firebaseAuthUID || id,
    convoMetrics: metricsToUpdate,
  });
};

export const getRatingMetricsToUpdate = ({ rate }: { rate?: number }) => {
  const metricsToUpdate: Object = {};
  metricsToUpdate[`Rated_${rate || 0}`] = 1;

  return metricsToUpdate;
};
